export const DEFAULT_REQUEST_HEADERS = { 'content-type': 'application/json' };
